module.exports = __webpack_public_path__ + "assets/flags/ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/ee.svg
// module id = 498
// module chunks = 0